// TODO: refactor jQuery --> ES
export default class AdminSearch {
	constructor(app) {
		this.app = app;
		const self = this;

		$(document).on("keyup", ".js-input-rellist", function (e) {
			// Delay searching and wait until has finished typing
			if (this.timer) {
				window.clearTimeout(this.timer);
			}
			let $this = $(this);
			this.timer = window.setTimeout(function () {
				if ($this.val().length >= 1 && e.which !== 13) {
					self._loadEntries($this);
				}
			}, 500)

		});

		$.fn.autolist = function () {
			$(this).each(function () {
				self._loadEntries($(this));
			});
		};

		$(".js-individuell-section").on("load", function () {
			$(".js-input-rellist").autolist();
		})

		//#TODO: this is a ugly hack to load the de-hk-admin-table initially
		$('.js-load-once.js-input-rellist').each(function () {
			self._loadEntries($(this).removeClass('js-load-once'));
		})

		//#TODO: this selectors ... argh
		$(document).on("click", "button[data-mode=del]", function (e) {
			let module = $(this).data("module");
			let aid = $(this).data("key");
			let pid = $(this).data("product_key");
			let $input = $(this).closest(".js-post-section").find('.js-input-rellist');

			$.post("/" + module + "/removeProduktRelation?key=" + aid + "&product_key=" + pid, function (data) {
				self._loadEntries($input);
			})
		});

		$(document).on("click", "button[data-mode=add]", function (e) {
			let module = $(this).data("module");
			let aid = $(this).data("key");
			let pid = $(this).data("product_key");
			let $input = $(this).closest(".js-post-section").find('.js-input-rellist');

			$.post("/" + module + "/addProduktRelation?key=" + aid + "&product_key=" + pid, function (data) {
				self._loadEntries($input);
			})
		});
	}


	_loadEntries($input) {
		let self = this;

		let name = $input.data("targetid");
		let requesturl = $input.data("request");
		let params = $input.data("params");

		// by default jQuery will parse the params, if they are JSON
		if (typeof params !== "object") {
			console.warn("Params are not a JSON-String. Try to parse old style");

			params = {};
			let temppar = params.split(",");
			// #TODO: Who needs standards? Who needs json-strings? ...
			$.each(temppar, function (i, val) {
				let tup = $.trim(val).split(":");
				if (tup.length >= 2) {
					params[tup[0]] = tup[1];
				}
			});
		}

		params["style"] = "entries";

		if (~requesturl.indexOf("_variante/")) {
			// perform full txt search with SQL
			params["search"] = $input.val();
		} else {
			// OLD search (var_gr)
			params["artnr"] = $input.val();
		}

		params["limit"] = 30;

		$.ajax({
			type: "POST",
			url: requesturl,
			data: params,
			success: function (data) {
				$("#" + name).empty().append(data);
			}
		});
	}
}
